import { render, staticRenderFns } from "./RemindTooptip.vue?vue&type=template&id=f88c8434"
import script from "./RemindTooptip.vue?vue&type=script&lang=js"
export * from "./RemindTooptip.vue?vue&type=script&lang=js"
import style0 from "./RemindTooptip.vue?vue&type=style&index=0&id=f88c8434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports